/*
 * ////////////////////////////////////////////////////////////////////////////////
 * //
 * // This software system consists of computer software and documentation.
 * // It contains trade secrets and confidential information which are proprietary
 * // to Everi Games Inc.  Its use or disclosure in whole or in part without
 * // the express written permission of Everi Games Inc. is prohibited.
 * //
 * // This software system is also an unpublished work protected under the copyright
 * // laws of the United States of America.
 * //
 * // Copyright © 2018 Everi Games Inc.  All Rights Reserved
 * //
 * ////////////////////////////////////////////////////////////////////////////////
 */
import EffectSequence from '../../../Effects/EffectSequence';
import ComponentBase from '../../ComponentBase';
import CLog from '../../ComponentLogger';
import { IAnimationOptions } from './AnimationInstanceBase';
import CocosAnimationInstance from './CocosAnimationInstance';
import EffectSequenceAnimationInstance from './EffectSequenceAnimationInstance';
import IAnimate from './IAnimate';
import SpineAnimationInstance from './SpineAnimationInstance';

export type AnimationType =  cc.Animation | sp.Skeleton | EffectSequence;

export default class AnimationWrapper implements IAnimate
{
    private animationInstance: IAnimate = null;

    constructor(value: AnimationType | cc.Node, options: IAnimationOptions = {})
    {
        if (value instanceof cc.Node)
        {
            value = ComponentBase.GetFirstComponent<AnimationType>(value, cc.Animation, sp.Skeleton, EffectSequence);
            if (!value)
            {
                CLog.error('Invalid animation type.');
                return;
            }
        }

        this.animationInstance = AnimationWrapper.InstanceFactory(value, options);
    }

    public Play(): Promise<any>
    {
        if (!this.animationInstance) { return Promise.reject(new Error('No animation instance.')); }
        return this.animationInstance.Play();
    }
    public Stop(): IAnimate
    {
        if (!this.animationInstance) { return this; }
        return this.animationInstance.Stop();
    }

    public static InstanceFactory(value: AnimationType, options: IAnimationOptions): IAnimate
    {
        if (value instanceof cc.Animation) { return new CocosAnimationInstance(value, options); }
        if (value instanceof sp.Skeleton) { return new SpineAnimationInstance(value, options); }
        if (value instanceof EffectSequence) { return new EffectSequenceAnimationInstance(value, options); }
        return null;
    }
}
